import { createContext } from 'react'

export const IsSsrMobileContext = createContext(false)

export default IsSsrMobileContext.Provider
